import {Api} from "@configs/api/api"
import apiConfig from "@configs/api/api.config"
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
const API_USER = "/api/billing/customers";
const API_ORDER ="/api/billing/transactions";
const API_BALANCE="/api/billing/billing-accounts/info";
const API_CONFIRM_STATUS="/api/billing/transactions";
const API_CANCEL="/api/billing/subscriptions/cancel-package";
class BaseApi extends Api {
    public constructor(config: AxiosRequestConfig){
        super(config);
        this.fetchUserList =  this.fetchUserList.bind(this);
        this.fetchOrderList = this.fetchOrderList.bind(this);
        this.fetchCurrentBalance = this.fetchCurrentBalance.bind(this);
        this.fetchConfirmStatus = this.fetchConfirmStatus.bind(this);
        this.fetchCancelCustomPackage = this.fetchCancelCustomPackage.bind(this);
    }
    public fetchCancelCustomPackage(body: any):Promise<any>{
        const header = {"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        return this.patch<any>(`${API_CANCEL}`, JSON.stringify(body),{headers: header})
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
    public fetchConfirmStatus(params: any): Promise<any>{
        const status = params.approve === false? "cancel": "approve"
        const header = {"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        return this.patch<any>(`${API_CONFIRM_STATUS}/${params.id}/${status}`,JSON.stringify({}),{headers: header})
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
    public fetchCurrentBalance (params: any): Promise<any>{
        const header = {"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        return this.get<any>(`${API_BALANCE}?id=${params.id}`,{
            headers: header
        })
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
    public fetchUserList (params: any): Promise<any>{
        const header = {"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        return this.get<any>(`${API_USER}?page=${params.page}&limit=10`
        + (params.email ? `&keywords=${params.email}` : '')
        + (params.createAt ? `&createdAt=${params.createAt}` : '')
        + (params.plan ? `&plan=${params.plan}` : ''), {
            headers: header
        })
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
    public fetchOrderList (params: any): Promise<any>{
        const header ={"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        return this.get<any>(`${API_ORDER}?page=${params.page}&limit=10&x-id-user=${params.id}&&status=${params.status === undefined ? '':params.status}`
        + (params.orderId ? `&id=${params.orderId}` : '') 
        + (params.createdAt ? `&createdAt=${params.createdAt}` : '')
        + (params.email ? `&email=${params.email}` : '')
        , {
            headers: header
        })
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
}
const baseApi = new BaseApi(apiConfig);
export default baseApi;
